import moment from 'moment';
import styles from './userCard.module.scss';
import {useNavigate} from 'react-router-dom';
import {useDispatch} from 'react-redux';
import {handleUserDisplayCurrency} from 'redux/store/app';

const UserCard = ({id, firstName, lastName, data, operations, imageUrl}) => {
  const fullName = `${firstName ?? ''} ${lastName ?? ''}`;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isDeleted = !!data?.isDeleted;
  const origination = (
    data?.source ||
    data?.currentSessionDetails?.medium ||
    ''
  ).toUpperCase();
  const isWebSession = origination === 'WEBSITE' || origination === 'WEB';
  return (
    <div
      key={id}
      onClick={() => {
        dispatch(handleUserDisplayCurrency(data?.preferredDisplayCurrency));
        operations?.view ? navigate(`/dashboard/user/${id}/overview`) : {};
      }}
      className={`${
        operations?.view ? styles.container : styles.disabledContainer
      } ${isDeleted ? styles.deleted : ''}`}>
      {isWebSession ? <div className={styles.webBadge}>Web</div> : null}
      <div className={styles['image-style']}>
        {imageUrl ? (
          <img src={imageUrl} alt="" />
        ) : (
          <div className={styles.dummyAvatar}>
            {firstName?.charAt(0)}
            {lastName?.charAt(0)}
          </div>
        )}
      </div>
      <h1>
        {fullName?.length > 20 ? fullName?.substring(0, 20) + '...' : fullName}
      </h1>
      {isDeleted ? (
        <span className={styles.deletedText}>Account deleted</span>
      ) : null}
      <div className={styles.date}>
        <span>
          <strong>Joined:</strong>{' '}
          {moment(data?.createdAt).format('DD MMM, YYYY')}
        </span>
        <span className={styles.lastSession}>
          <strong>Last Session:</strong>{' '}
          {moment(data?.currentSessionDetails?.currentDateTime).format(
            'DD MMM, YY. hh:mm A',
          )}
        </span>
      </div>
    </div>
  );
};

export default UserCard;
